/** Snapshot of manual ingest fields used for strip expand guard. */
export type ManualIngestDirtySnapshot = {
  body: string;
  creativeDescription: string;
  externalId: string;
  slotFillJsonText: string;
  platformCta: string;
  templateId: string;
  qualityRating: string;
  qualityNote: string;
  promotedExemplar: boolean;
  selectedCats: Set<string>;
  selectedPostTags: Set<string>;
  manualPostMediaFiles: readonly unknown[];
  publishOverrideOpen: boolean;
  publishedAt: string;
};

export function isManualIngestDirty(s: ManualIngestDirtySnapshot): boolean {
  if (s.body.trim()) return true;
  if (s.creativeDescription.trim()) return true;
  if (s.externalId.trim()) return true;
  if (s.slotFillJsonText.trim()) return true;
  if (s.platformCta.trim()) return true;
  if (s.templateId.trim()) return true;
  if (s.qualityRating) return true;
  if (s.qualityNote.trim()) return true;
  if (s.promotedExemplar) return true;
  if (s.selectedCats.size > 0) return true;
  if (s.selectedPostTags.size > 0) return true;
  if (s.manualPostMediaFiles.length > 0) return true;
  if (s.publishOverrideOpen && s.publishedAt.trim()) return true;
  return false;
}
